import React from 'react';
import "./Policy.css";
import { Helmet } from "@dr.pogodin/react-helmet";

function RefundPolicy() {
  return (
    <div className='ppMn'>
      <Helmet>
        <title>Refund & Cancellation Policy | PAYTECH ADVISOR</title>
      </Helmet>

      <div className="ppCon">
        <div className="maxW">
          <h1>Refund & Cancellation Policy</h1>

          <div className="ppSection">
            <h2>Consultancy & Advisory Fees</h2>
            <ul>
              <li>Payments made for consultancy, advisory, or onboarding services are non-refundable once services have commenced or payments have been remitted to third-party partners.</li>
              <li>Commitments may be confirmed through formal communication, including email, WhatsApp, or other written/electronic acknowledgment.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Advance Payments</h2>
            <ul>
              <li>Any advance payment made for specific projects is non-adjustable and non-refundable, regardless of whether services are terminated mutually or unilaterally, and regardless of the stage of delivery.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Refund Eligibility</h2>
            <p>Refunds will be processed only in the following cases:</p>
            <ul>
              <li>Duplicate payment made due to a technical error.</li>
              <li>Services not initiated within the committed timeline (unless delayed due to client dependencies).</li>
              <li>Failure of third-party providers to commence or deliver agreed services/products where Paytech Advisors has a dependency.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Refund Process</h2>
            <ul>
              <li>Refund requests must be submitted within 7 working days of payment by emailing <a href="mailto:info@paytechadvisors.com">info@paytechadvisors.com</a>.</li>
              <li>Approved refunds will be processed within 15–25 working days to the original payment method.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Cancellation Policy</h2>
            <ul>
              <li>A written cancellation notice must be provided at least 45 days in advance and will be valid only if accepted by Paytech Advisors or its registered entity, K.M Enterprises.</li>
              <li>For subscription or retainer-based contracts, cancellations will apply only from the next billing cycle. No refunds or adjustments will be made for the ongoing cycle.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

export default RefundPolicy;
